import { Head } from '@inertiajs/react';
import type { AdminStagesIndex } from '@/types';
import { CreateStageForm } from './components/CreateStageForm';
import { ShuffleAcrossButton } from './components/ShuffleAcrossButton';
import { StagesTabs } from './components/StagesTabs';

export default function Index({
  stages,
  allProjects,
  title,
  eventSlug,
  eventName,
}: AdminStagesIndex) {
  return (
    <>
      <Head title={title} />
      <div className="container mx-auto flex max-w-4xl flex-col gap-5 py-6">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <h1 className="font-bold text-2xl">Stages — {eventName}</h1>
          <div className="flex flex-wrap gap-2">
            <ShuffleAcrossButton
              eventSlug={eventSlug}
              stageCount={stages.length}
              projectCount={allProjects.length}
            />
            <CreateStageForm eventSlug={eventSlug} />
          </div>
        </div>

        {stages.length === 0 ? (
          <p className="text-muted-foreground text-sm">
            No stages yet — create one with the “New stage” button.
          </p>
        ) : (
          <StagesTabs eventSlug={eventSlug} stages={stages} />
        )}
      </div>
    </>
  );
}
